import { ResponseModelInterfaceStatic } from "@/service/models/response-model-interface";
import { DosageSequenceVM } from "@/service/view-models/dosage-choices/dosage-sequence-vm";
import { staticImplements } from "@/utilities/static-implements";
import { Duration } from "@/utilities/types/duration";
import { XmlDocumentWrapper } from "@/utilities/xml-helpers/xml-document-wrapper";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { BaseDosageChoice } from ".";
import { FormulationAndRouteEnums } from "../../parts/formulation-and-route-enums";
import { FormulationAndRoute } from "../parts/formulation-and-route";

@staticImplements<ResponseModelInterfaceStatic>()
export class DosageSequence extends BaseDosageChoice
{
    public constructor(
        public dosages: BaseDosageChoice[],
    )
    {
        super();
    }

    /**
     * @inheritdoc
     */
    public makeViewModel(): DosageSequenceVM
    {
        return new DosageSequenceVM().fillFromModel(this);
    }

    /**
     * @inheritdoc
     */
    public getClosestNextDoseDate(knownDose: Date, current: Date): Date
    {
        return current; // TODO: not implemented yet
    }

    /**
     * @inheritdoc
     */
    public getClosestPreviousDoseDate(knownDose: Date, current: Date): Date
    {
        return current; // TODO: not implemented yet
    }

    /**
     * @inheritdoc
     */
    public getDoseValueForDisplay(): number
    {
        return this.dosages[0]?.getDoseValueForDisplay() ?? 0;
    }

    /**
     * @inheritdoc
     */
    public getDoseUnitForDisplay(): string
    {
        return this.dosages[0]?.getDoseUnitForDisplay() ?? '';
    }

    /**
     * @inheritdoc
     */
    public getInfusionTimeForDisplay(): Duration|null
    {
        return this.dosages[0]?.getInfusionTimeForDisplay() ?? null;
    }

    /**
     * @inheritdoc
     */
    public getIntervalForDisplay(): Duration
    {
        return this.dosages[0]?.getIntervalForDisplay() ?? Duration.fromSeconds(0);
    }

    /**
     * @inheritdoc
     */
    public getRouteForDisplay(): FormulationAndRoute
    {
        return this.dosages[0]?.getRouteForDisplay() ?? new FormulationAndRoute(
            "",
            "",
            FormulationAndRouteEnums.AdministrationRoute.ORAL,
            FormulationAndRouteEnums.AbsorptionModelComputation.UNDEFINED
        );
    }

    /**
     * @inheritdoc
     */
    public static makeFromXml(elem: XmlElementWrapper): DosageSequence
    {
        return new this(
            elem.mapForEachChildTagIn(BaseDosageChoice.allowedTagNames, (elem) => BaseDosageChoice.makeFromXmlGeneric(elem)),
        );
    }

    /**
     * @inheritdoc
     */
    public getXml(doc: XmlDocumentWrapper): XmlElementWrapper
    {
        const element = doc.createElement("dosageSequence");

        for (const dosage of this.dosages) {
            element.append(dosage.getXml(doc));
        }

        return element;
    }
}
